module.exports = __webpack_public_path__ + "img/xyLogo.3d01d798.png";